<p-table #ut [value]="items" (onEditInit)="startEdit($event)" (onEditComplete)="updateTotal($event)">
	<ng-template pTemplate="header" let-columns>
		<tr>
			<th *ngFor="let col of cols" class="{{col.class + '-col'}} col-header">
				{{col.header}}
			</th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-rowData let-columns="cols">
		<tr [pSelectableRow]="rowData" *ngIf="rowData.id">
			<!-- <td *ngFor="let col of cols" class="{{col.class + '-col'}}">
				<ng-container>
					<div class="table-div">{{getFieldData(rowData, col)}}</div>
				</ng-container>
			</td> -->

			<td class="hash-col">
				{{rowData.id}}
			</td>
			<td pEditableColumn class="product-col editable-cell">
				<p-cellEditor>
					<ng-template pTemplate="input">
						<p-dropdown [options]="qbServs" [(ngModel)]="rowData.salesItemLineDetail.itemRef.name"
							(ngModelChange)="servChanged(rowData)" placeholder="Service" [filter]="true">
						</p-dropdown>

						<!-- <input pInputText type="string" class="material-input-text"
							[(ngModel)]="rowData.salesItemLineDetail.itemRef.name"> -->
					</ng-template>
					<ng-template pTemplate="output">
						{{rowData.salesItemLineDetail?.itemRef?.name}}
					</ng-template>
				</p-cellEditor>
			</td>
			<td pEditableColumn class="description-col editable-cell">
				<p-cellEditor>
					<ng-template pTemplate="input">
						<textarea pInputTextarea type="string" class="material-input-text material-textarea-text"
							[(ngModel)]="rowData.description"></textarea>
					</ng-template>
					<ng-template pTemplate="output">
						{{rowData.description}}
					</ng-template>
				</p-cellEditor>
			</td>
			<td pEditableColumn class="classes-col product-col editable-cell">
				<p-cellEditor>
					<ng-template pTemplate="input">
						<p-dropdown [options]="qbClasses"
							[(ngModel)]="rowData?.salesItemLineDetail?.classRef && rowData?.salesItemLineDetail?.classRef.name"
							(ngModelChange)="rowData.salesItemLineDetail.classRef = {}; rowData.salesItemLineDetail.classRef.name = $event; classChanged(rowData)"
							placeholder="Class" [filter]="true">
						</p-dropdown>
					</ng-template>
					<ng-template pTemplate="output">
						{{rowData.salesItemLineDetail?.classRef?.name}}
					</ng-template>
				</p-cellEditor>
			</td>
			<td [pEditableColumn]="rowData.id" [pEditableColumnField]="'salesItemLineDetail.qty'"
				[pEditableColumnRowIndex]="rowData.id" class="quantity-col editable-cell">
				<p-cellEditor>
					<ng-template pTemplate="input">
						<input pInputText BlockLateralArrowNavigation type="string" class="material-input-text"
							[(ngModel)]="rowData.salesItemLineDetail.qty">
					</ng-template>
					<ng-template pTemplate="output">
						{{rowData.salesItemLineDetail?.qty}}
					</ng-template>
				</p-cellEditor>
			</td>
			<td [pEditableColumn]="rowData.salesItemLineDetail?.unitPrice" [pEditableColumnRowIndex]="rowData.id"
				[pEditableColumnField]="'salesItemLineDetail.unitPrice'" class="rate-col editable-cell">
				<p-cellEditor>
					<ng-template pTemplate="input">
						<input pInputText BlockLateralArrowNavigation type="string" class="material-input-text"
							[(ngModel)]="rowData.salesItemLineDetail.unitPrice">
					</ng-template>
					<ng-template pTemplate="output">
						{{rowData.salesItemLineDetail?.unitPrice | number}}
					</ng-template>
				</p-cellEditor>
			</td>
			<td class="amount-col not-editable-cell">
				{{rowData.amount | number}}
			</td>
			<td class="delete-col not-editable-cell" (click)="deleteLine(rowData.id)">
				<i class="pi pi-trash" style="font-size: 100%"></i>
			</td>
		</tr>
	</ng-template>
</p-table>

<div class="additional-block">
	<button mat-button class="add-line-button" (click)="addLines()">
		<mat-icon>add</mat-icon>
		<div class="button-title">Add line</div>
	</button>
</div>
